import { render, staticRenderFns } from "./Regolamenti.vue?vue&type=template&id=530ff42e&"
import script from "./Regolamenti.vue?vue&type=script&lang=js&"
export * from "./Regolamenti.vue?vue&type=script&lang=js&"
import style0 from "./Regolamenti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports